import { render, staticRenderFns } from "./systemMessage1.vue?vue&type=template&id=6c1d0640&scoped=true"
import script from "./systemMessage1.vue?vue&type=script&lang=js"
export * from "./systemMessage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1d0640",
  null
  
)

export default component.exports